export class Platform {
    static userAgent = window.navigator.userAgent;
    static platform = window.navigator.platform;

    static isDesktopMac() {
        return ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'].indexOf(Platform.platform) !== -1;
    }

    static isDesktopPC() {
        return ['Win32', 'Win64', 'Windows', 'WinCE'].indexOf(Platform.platform) !== -1;
    }

    static isAndroid() {
        return /Android/.test(Platform.userAgent);
    }

    static isIOS() {
        if (['iPhone', 'iPad', 'iPod'].indexOf(Platform.platform) !== -1 ||
            Platform.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2) {
            return true
        };
    }

    static isKindle() {
        return /Kindle|Silk|KFAPW|KFARWI|KFASWI|KFFOWI|KFJW|KFMEWI|KFOT|KFSAW|KFSOWI|KFTBW|KFTHW|KFTT|WFFOWI/i.test(Platform.userAgent)
    }

    static getOS() {
        const platFormCheckMap = new Map([
            ['desktopMac', Platform.isDesktopMac],
            ['desktopPC', Platform.isDesktopPC],
            ['android', Platform.isAndroid],
            ['kindle', Platform.isKindle],
            ['ios', Platform.isIOS],
        ]);

        let os;
        for ( let [platform, platformTest] of platFormCheckMap) {
            if (platformTest())
                os = platform
        }

        return os;
    }

    static isDesktop() {
        return ['desktopMac', 'desktopPC'].indexOf(Platform.getOS()) !== -1
    }
}